module.exports = __webpack_public_path__ + "img/thirteenimg4.0079675a.png";